<template>
  <div>

    <div class="input-avatar">
      <label for="" v-if="!avatar">
        <plus-circle-icon />
        <input type="file" @change="onFileChange">
        <account-circle-icon class="img" />
        <!-- Faça o upload de sua foto -->
      </label>

      <label for="" v-else>
        <pencil-circle-icon />
        <input type="file" @change="onFileChange">
        <img :src="avatar">
        <!-- Altere sua foto -->
      </label>
    </div>

    <b-modal ref="input-avatar-modal" size="md" centered :hide-header="true" :hide-footer="true">
      <LoaderContent v-if="isSaving || isLoading" :welcomeMessage="false" :alignSpinnerTop="false" />

      <vue-croppie
        style="position:relative;z-index:0;height:auto;"
        ref="croppieRef"
        :viewport="{ width: 200, height: 200 }"
        :boundary="{ width: '100%', height: 400 }"
        :enableResize="false"
        @result="result">
      </vue-croppie>

      <div class="d-flex justify-content-center align-items-center mb-5">
        <button class="btn btn-outline-blue-ml" @click="rotate(-90)">Girar Foto</button>
      </div>

      <div class="d-flex align-items-center">
        <button type="button" class="btn btn-link mr-auto" @click="$refs['input-avatar-modal'].hide()">Cancelar</button>
        <button type="button" class="btn btn-blue-ml" @click="cropViaEvent()">Salvar</button>
      </div>
    </b-modal>

  </div>
</template>

<script>
  import LoaderContent from 'ninenine-white-label/src/components/Loader/LoaderContent.vue'
  import AccountCircleIcon from "vue-material-design-icons/AccountCircle.vue"
  import PlusCircleIcon from "vue-material-design-icons/PlusCircle.vue"
  import PencilCircleIcon from "vue-material-design-icons/PencilCircle.vue"
  import * as heic2any from 'heic2any'

  export default {
    name: 'InputAvatar',

    data() {
      return {
        isSaving: false,
        isLoading: false,
      }
    },

    computed: {
      avatar(){
        return this.$store.state.user.avatar || null;
      }
    },

    components: {
      LoaderContent,
      AccountCircleIcon,
      PlusCircleIcon,
      PencilCircleIcon
    },

    methods: {
      onFileChange(e) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length)
          return;
        this.createImage(files[0]);

        this.$parent.$el.style.position = 'static'
      },

      rotate(rotationAngle) {
        this.$refs.croppieRef.rotate(rotationAngle);
      },

      async createImage(file) {
        var image = new Image();
        var reader = new FileReader();
        var vm = this;

        var fileName = file.name.replace(/[^a-z0-9]/gi, '');
        var fileFormat = file.name.split(".").pop();

        var formatos = ['png', 'jpg', 'jpeg', 'heic'];
        var maxSize =  2100000;

        if( formatos.indexOf(fileFormat.toLowerCase()) == -1 ){
          vm.$refs['input-avatar-modal'].hide();
          this.$swal('Falha no carregamento da foto', 'Sua foto deve estar no formato .png, .jpg ou .jpeg', 'error');
          return false;
        }

        if( file.size > maxSize ){
          vm.$refs['input-avatar-modal'].hide();
          this.$swal('Falha no carregamento da foto', 'Sua foto não pode ter mais que 2MB', 'error');
          return false;
        }

        this.isLoading = true;
        vm.$refs['input-avatar-modal'].show()

        if (file.type === "image/heic" || file.type === "image/heif") {
          file = await heic2any({
            blob: file,
            toType: "image/jpeg"
          });
        }

        reader.onload = (e) => {
          setTimeout(() => {
            this.isLoading = false;
            vm.$refs.croppieRef.bind({
              url: e.target.result
            })
          }, 100)
        };

        reader.readAsDataURL(file);
      },

      cropViaEvent() {
        let options = {
          format: 'png',
          circle: false
        }
        this.$refs.croppieRef.result(options);
      },

      result(output) {
        this.isSaving = true;
        this.$store.dispatch('user/uploadUserAvatar', {
          image: output
        }).then((response) => {
          this.isSaving = false;
          this.$refs['input-avatar-modal'].hide()
          this.$parent.$el.removeAttribute('style')
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .input-avatar{
    label{
      max-width: 270px;
      overflow: hidden;
      position: relative;
      display: inline-flex;
      align-items: center;

      &:hover{
        color: theme-color-level('blue-ml', 1);

        .account-circle-icon{
          color: theme-color-level(secondary, 1);
        }

        .plus-circle-icon,
        .pencil-circle-icon{
          color: theme-color-level('blue-ml', 1);
        }
      }
    }

    img,
    .img{
      width: 60px;
      height: 60px;
      border-radius: 50%;
      margin: 0 .5rem 0 0;
      object-fit: cover;
      background: white;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .account-circle-icon{
      font-size: 60px;
      margin: 0 .5rem 0 0;
      color: theme-color-level(secondary, 0);
    }

    .plus-circle-icon,
    .pencil-circle-icon{
      font-size: 24px;
      position: absolute;
      bottom: 0;
      left: 60%;
      color: theme-color-level('blue-ml', 0);
      z-index: 1;
      &:before{
        content: "";
        width: 100%;
        height: 100%;
        background: white;
        border-radius: 50%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 0;
      }

      /deep/ & > .material-design-icon__svg{ position: relative !important; bottom: 0; }
    }

    input[type="file"]{
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      opacity: 0;
      z-index: 1;
      cursor: pointer;
    }
  }
</style>